module.exports = __webpack_public_path__ + "img/verticalIco5.565d03f9.png";